export const sliceNames = {
  emailName: "email",
};
